<template>
    <div class="legal-card" @click="goToLegalPage">
        <div class="legal-card__title">
            {{title}}
        </div>
        <div class="legal-card__link">
            Vezi pagina
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            title: {
                type: String,
                default: ''
            },
            slug: {
                type: String,
                default: ''
            }
        },
        methods: {
            goToLegalPage() {
                this.$router.push(`/help/${this.slug}`);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .legal-card {
        min-width: 250px;
        width: 250px;
        min-height: 250px;
        height: 250px;
        background-color: $color-card;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        border-bottom: 3px solid $color-secondary;
        transition: border-color .2s;
        -webkit-box-shadow: 0px 2px 8px 0px rgba(99, 99, 99, 0.2);
        -moz-box-shadow: 0px 2px 8px 0px rgba(99, 99, 99, 0.2);
        box-shadow: 0px 2px 8px 0px rgba(99, 99, 99, 0.2);
        cursor: pointer;

        &__title {
            font-size: 24px;
            font-weight: 500;
            line-height: 29.78px;
            color: $color-primary;
            text-align: center;
            margin-bottom: 5px;
        }

        &__link {
            font-size: 14px;
            line-height: 17.36px;
            text-align: center;
            color: $color-gray;
        }

        &:hover {
            border-color: $color-primary;
        }

        &:hover &__link {
            text-decoration: underline;
        }
    }
</style>